import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { NavDropdown } from 'react-bootstrap';

const languages = [
  { key: 'English', text: 'Eng', value: 'en' },
  { key: 'French', text: 'Fr', value: 'fr' },
  { key: 'Kiswahili', text: 'Sw', value: 'sw' },
  { key: 'Kinyarwanda', text: 'Kiny', value: 'rw' },
];

const SelectLanguage = () => {
  const [currentLang, setCurrentLang] = useState(languages[0].value);
  const { i18n } = useTranslation();

  const changeLanguage = useCallback(
    lang => {
      i18n.changeLanguage(lang?.value);
      localStorage.setItem('language', lang?.value);
      setCurrentLang(lang?.value);
    },
    [i18n],
  );

  return (
    <NavDropdown title={currentLang} className="text-white" id="basic-nav-dropdown">
      {React.Children.toArray(
        languages?.map(
          lang =>
            currentLang !== lang?.value && (
              <NavDropdown.Item className="text-blue-darken" onClick={e => changeLanguage(lang)}>
                {lang?.key}
              </NavDropdown.Item>
            ),
        ),
      )}
    </NavDropdown>
  );
};

export default SelectLanguage;
